module.exports = __webpack_public_path__ + "static/media/7.e8c4c0c1.jpg";